/**
 * Gobelet animé : respect de « prefers-reduced-motion ».
 *
 * Les animations du gobelet sont du SMIL, que le CSS ne peut pas désactiver.
 * On les met donc en pause via l'API SVG, sur le premier cycle rendu, et on
 * suit les changements de préférence système sans recharger la page.
 */
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');

  const appliquer = () => {
    document.querySelectorAll('[data-oyw-gobelet] svg').forEach((svg) => {
      if (typeof svg.pauseAnimations !== 'function') return;
      if (preference.matches) {
        // Un instant non nul montre le gobelet partiellement rempli plutôt que vide.
        svg.setCurrentTime(4);
        svg.pauseAnimations();
      } else {
        svg.unpauseAnimations();
      }
    });
  };

  appliquer();
  preference.addEventListener('change', appliquer);
})();
